"use strict";

exports.__esModule = true;
var _ProfileDialog = require("./ProfileDialog");
Object.keys(_ProfileDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfileDialog[key]) return;
  exports[key] = _ProfileDialog[key];
});